import React from 'react';
import { Card } from '../shared/Card';
interface NutritionScreenProps {
  navigateTo: (screen: string) => void;
}
export const NutritionScreen = ({
  navigateTo
}: NutritionScreenProps) => {
  return <div className="flex flex-col h-full min-h-screen bg-white pb-16" data-id="element-584">
      <header className="p-6 border-b border-gray-100" data-id="element-585">
        <h1 className="text-xl font-bold text-gray-900" data-id="element-586">Nutrition</h1>
        <p className="text-gray-500" data-id="element-587">Track your meals and nutrition</p>
      </header>
      <main className="flex-1 p-6 space-y-6 overflow-y-auto" data-id="element-588">
        <Card className="p-4" data-id="element-589">
          <h2 className="text-lg font-medium mb-2" data-id="element-590">Today's Summary</h2>
          <div className="grid grid-cols-3 gap-4 text-center" data-id="element-591">
            <div className="bg-blue-50 p-3 rounded-lg" data-id="element-592">
              <p className="text-xs text-gray-500" data-id="element-593">Calories</p>
              <p className="text-lg font-bold text-blue-600" data-id="element-594">1,450</p>
              <p className="text-xs text-gray-500" data-id="element-595">/ 2,200</p>
            </div>
            <div className="bg-green-50 p-3 rounded-lg" data-id="element-596">
              <p className="text-xs text-gray-500" data-id="element-597">Protein</p>
              <p className="text-lg font-bold text-green-600" data-id="element-598">85g</p>
              <p className="text-xs text-gray-500" data-id="element-599">/ 120g</p>
            </div>
            <div className="bg-orange-50 p-3 rounded-lg" data-id="element-600">
              <p className="text-xs text-gray-500" data-id="element-601">Water</p>
              <p className="text-lg font-bold text-orange-600" data-id="element-602">4</p>
              <p className="text-xs text-gray-500" data-id="element-603">/ 8 cups</p>
            </div>
          </div>
        </Card>
        <Card className="p-4" data-id="element-604">
          <div className="flex justify-between items-center mb-4" data-id="element-605">
            <h2 className="text-lg font-medium" data-id="element-606">Today's Meals</h2>
            <button className="text-blue-500 text-sm font-medium" data-id="element-607">+ Add</button>
          </div>
          <div className="space-y-4" data-id="element-608">
            <div className="flex items-center p-3 bg-gray-50 rounded-lg" data-id="element-609">
              <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center text-blue-500 mr-3" data-id="element-610">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-611">
                  <path d="M18 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2Z" data-id="element-612"></path>
                  <path d="M6 12h12" data-id="element-613"></path>
                  <path d="M6 17h12" data-id="element-614"></path>
                  <path d="M6 7h12" data-id="element-615"></path>
                </svg>
              </div>
              <div className="flex-1" data-id="element-616">
                <h3 className="font-medium" data-id="element-617">Breakfast</h3>
                <p className="text-sm text-gray-500" data-id="element-618">Oatmeal with berries</p>
              </div>
              <div className="text-right" data-id="element-619">
                <p className="font-medium" data-id="element-620">320</p>
                <p className="text-xs text-gray-500" data-id="element-621">calories</p>
              </div>
            </div>
            <div className="flex items-center p-3 bg-gray-50 rounded-lg" data-id="element-622">
              <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center text-green-500 mr-3" data-id="element-623">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-624">
                  <path d="M18 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2Z" data-id="element-625"></path>
                  <path d="M6 12h12" data-id="element-626"></path>
                  <path d="M6 17h12" data-id="element-627"></path>
                  <path d="M6 7h12" data-id="element-628"></path>
                </svg>
              </div>
              <div className="flex-1" data-id="element-629">
                <h3 className="font-medium" data-id="element-630">Lunch</h3>
                <p className="text-sm text-gray-500" data-id="element-631">Grilled chicken salad</p>
              </div>
              <div className="text-right" data-id="element-632">
                <p className="font-medium" data-id="element-633">450</p>
                <p className="text-xs text-gray-500" data-id="element-634">calories</p>
              </div>
            </div>
            <div className="flex items-center p-3 bg-gray-50 rounded-lg" data-id="element-635">
              <div className="w-10 h-10 bg-orange-100 rounded-full flex items-center justify-center text-orange-500 mr-3" data-id="element-636">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-637">
                  <path d="M18 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2Z" data-id="element-638"></path>
                  <path d="M6 12h12" data-id="element-639"></path>
                  <path d="M6 17h12" data-id="element-640"></path>
                  <path d="M6 7h12" data-id="element-641"></path>
                </svg>
              </div>
              <div className="flex-1" data-id="element-642">
                <h3 className="font-medium" data-id="element-643">Snack</h3>
                <p className="text-sm text-gray-500" data-id="element-644">Greek yogurt with honey</p>
              </div>
              <div className="text-right" data-id="element-645">
                <p className="font-medium" data-id="element-646">180</p>
                <p className="text-xs text-gray-500" data-id="element-647">calories</p>
              </div>
            </div>
          </div>
        </Card>
        <Card className="p-4" data-id="element-648">
          <h2 className="text-lg font-medium mb-2" data-id="element-649">Meal Planning</h2>
          <p className="text-gray-500 text-sm mb-4" data-id="element-650">
            Get personalized meal recommendations based on your fitness goals
          </p>
          <button className="w-full bg-blue-500 text-white py-2 rounded-lg font-medium" data-id="element-651">
            Create Meal Plan
          </button>
        </Card>
      </main>
    </div>;
};